import { SearchResultsDisplay } from "@features/search/SearchResultsDisplay"
import { useSearchResults } from "@features/search/useSearchResults"
import { useIsMobile } from "@hooks/useIsMobile"
import { useHydrating, useSearchParams } from "eddev/routing"
import { defineView } from "eddev/views"
import type { SFFRagDocumentTypeName } from "../server/search/rag"

export default defineView("search-results", (props) => {
  const hydrating = useHydrating()
  const [params, paramsApi] = useSearchParams({
    q: "",
    types: [] as SFFRagDocumentTypeName[],
  })

  const isMobile = useIsMobile(600)

  const search = useSearchResults({
    types: params.types,
    enabled: true,
    isMobile: isMobile,
    isQuickSearch: false,
  })

  if (hydrating) {
    return <div className="h-[60vh]" />
  }

  return (
    <>
      <div className="grid-auto">
        <div className="col-span-12">
          <SearchResultsDisplay
            types={params.types}
            setTypes={paramsApi.setter("types")}
            search={search}
            isSmall={isMobile}
            isFull
          />
        </div>
      </div>
      <div className="h-10" />
    </>
  )
})
